var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPointsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#5B587D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79206 15H10.7383V13.8435C12.222 13.715 13.2617 12.8621 13.2617 11.5888C13.2617 10.3154 12.5023 9.6028 10.7266 9.15888V6.93925C11.2757 7.05607 11.8014 7.3014 12.3154 7.68692L12.9696 6.58879C12.3271 6.10981 11.5911 5.80607 10.7383 5.70093V5H9.79206V5.67757C8.33178 5.79439 7.30374 6.6472 7.30374 7.90888C7.30374 9.24065 8.09813 9.88318 9.80374 10.3271V12.6168C9.04439 12.5 8.41355 12.1495 7.74766 11.6121L7 12.6752C7.79439 13.3061 8.7757 13.715 9.79206 13.8318V15ZM9.80374 8.91355C8.90421 8.64486 8.68224 8.32944 8.68224 7.85047C8.68224 7.31308 9.06776 6.91589 9.80374 6.85748V8.91355ZM10.7266 12.6636V10.5491C11.6378 10.8178 11.8832 11.1332 11.8832 11.6472C11.8832 12.2313 11.4626 12.6051 10.7266 12.6636Z",
    fill: "#5B587D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPointsIcon);
export default __webpack_public_path__ + "static/media/MyPointsIcon.406bc27df54c30b8fad80b522dc09875.svg";
export { ForwardRef as ReactComponent };